/**
 * 移动端本地编辑，实现 MegaBrokerMobile
 * 品类引用 js 文件，并将 broker 挂载在 window 上
 */
import { MEGA_BROKER_API } from '@tencent/mega-ipc-shared';
import { MegaFileService, MegaDocxService, MegaMediaService, MegaReportService } from '@tencent/mega-mobile-services';
import ServiceHost from './service-host';
function createMegaBroker() {
    return {
        loadProtocol: (name) => {
            const service = ServiceHost.getService(name);
            return {
                protocol: {
                    apis: service.apis || [],
                    channels: service.channels || [],
                    version: service.version,
                },
                broker: service,
            };
        },
        transport: ServiceHost.transport,
    };
}
export function registerServices() {
    // service 注册
    ServiceHost.register({
        services: {
            file: new MegaFileService(ServiceHost.transport),
            docx: new MegaDocxService(ServiceHost.transport),
            media: new MegaMediaService(ServiceHost.transport),
            report: new MegaReportService(),
        },
        onRegisterError: (serviceName, err) => {
            // eslint-disable-next-line no-console
            console.error('[Mega Mobile]', `Service "${serviceName}" is failed to register:`, JSON.stringify(err.stack));
        },
    });
}
export function registerMegaBroker() {
    Reflect.set(window, MEGA_BROKER_API, createMegaBroker());
}
//# sourceMappingURL=mega-broker.js.map